
/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold pt-3">All Questions</h4>
        <h5>{{title}}</h5>
        <button class="btn btn-info btn-block my-4" @click.prevent="clickedAddButton()">Add a Quiz</button>

        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col-6">Question</th>
                        <th scope="col-4">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in questions" :key="item._id">
                        <th>{{item.question}}</th>
                        <td>
                            <button class="btn btn-success btn-sm" @click.prevent="clickedEditButton(item)">Edit</button>
                            <button class="btn btn-danger btn-sm" @click.prevent="deleteItem(item._id)">Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <mdb-container>
        <mdb-modal :show="showeditmodal" removeBackdrop centered size="xl">
            <mdb-modal-body>
                <form class="border border-light p-5" >
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Question</label>
                            <textarea v-model="quiz.question" id="" class="form-control mb-4" rows="2" placeholder="Question">
                            </textarea>
                        </div>

                        <div class="form-group col-md-6" v-if="modaltype=='add' && quiz.mediaType != 'blank'">
                            <label>Media</label>
                            <input type="file" ref="media" class="form-control mb-4" accept="image/jpeg, image/png" v-if="quiz.mediaType == 'image'">
                            <input type="text" class="form-control mb-4" v-if="quiz.mediaType == 'video'" placeholder="Vimeo Video ID" v-model="quiz.media">
                        </div>

                        <div class="form-group col-md-12">
                            <label>Correct Answer</label>
                            <select class="form-control mb-4" v-model="quiz.correct">
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="D">D</option>
                            </select>
                        </div>
                      

                        <div class="form-group col-md-6">
                            <label>Answer A</label>
                            <textarea v-model="quiz.answerA" id="" class="form-control mb-4" rows="2" placeholder="Answer A">
                            </textarea>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Answer B</label>
                            <textarea v-model="quiz.answerB" id="" class="form-control mb-4" rows="2" placeholder="Answer B">
                            </textarea>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Answer C</label>
                            <textarea v-model="quiz.answerC" id="" class="form-control mb-4" rows="2" placeholder="Answer C">
                            </textarea>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Answer D</label>
                            <textarea v-model="quiz.answerD" id="" class="form-control mb-4" rows="2" placeholder="Answer D">
                            </textarea>
                        </div>
                    </div>

                    <!-- Sign in button -->
                    <button class="btn btn-info btn-block my-4" @click.prevent="editItem()" v-if="modaltype=='edit'">EDIT A QUIZ</button>
                    <button class="btn btn-info btn-block my-4" @click.prevent="addItem()" v-if="modaltype=='add'">ADD A QUIZ</button>

                </form>
                <div class="modal-footer">
                    <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          data-dismiss="modal"
                          @click="showeditmodal = false"
                        >
                          Close
                    </button>
                </div>
            </mdb-modal-body>
            </mdb-modal>
    </mdb-container>
</div>


</template>

<script>
import axios from "axios"

import { mdbContainer, mdbModal, mdbModalBody } from "mdbvue";

export default {
    name: 'Quizs',
    components: {
        mdbContainer,
        mdbModal,
        mdbModalBody,
    },
    data() {
        return {
            id: this.$route.params.documentId,
            title: this.$route.params.title,
            questions: [],
            quiz: {},
            showeditmodal: false,
            modaltype: 'add',
            validated: false,
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.$toast.open({
                message: "Processing : Loading Levels Please Wait...",
                type: 'info'
            })

            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }

            axios.get(this.$apiURI + `/document/${this.id}/quizs`, config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        
                        // eslint-disable-next-line no-console
                        // console.log(response.data.data.teachers)
                        this.questions = response.data.data.quizs;
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        },
        deleteItem(id) {
            if(confirm('Are you sure?') == true) {
                const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }

                axios.get(this.$apiURI + '/document/quiz/' + id + '/delete', config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        
                        // eslint-disable-next-line no-console
                        // console.log(response.data.data.teachers)
                        this.initData();

                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
            }
        },
        clickedAddButton() {
            this.modaltype = 'add';
            this.quiz = {
                question: '',
                correct: '',
                mediaType: 'blank',
                media: '',
                time: 1 ,
                answerA: '',
                answerB: '',
                answerC: '',
                answerD: '',
                document_id: this.id,
            };
            this.showeditmodal = true;
        },
        clickedEditButton(quiz) {
            this.modaltype = 'edit';
            this.quiz = quiz;
            this.showeditmodal = true;
        },
        editItem() {
            this.validated = false;
            this.validate()
            if(this.validated) {
                this.showeditmodal = false;
                const config = {
                        headers: {
                            Authorization: "Bearer " + this.fastAdminToken,
                            'Content-Type': 'application/json'
                        }
                    }
                    this.$toast.open({
                        message: "Processing : Adding a Quiz. Please Wait...",
                        type: 'info'
                    })

                    axios.post(this.$apiURI + `/document/quiz/${this.quiz._id}/update`, this.quiz, config)
                        .then((response) => {
                            this.loading = false;
                            if (response.data.error) {
                                this.$toast.open({
                                    message: "Error : " + response.data.message,
                                    type: 'error'
                                });

                            } else {
                                this.$toast.open({
                                    message: "A Quiz Created Successfully",
                                    type: 'success'
                                })
                                this.initData();

                            }

                        }).catch((error) => {
                            this.loading = false;
                            this.$toast.open({
                                message: "Error : " + error.response.data.message,
                                type: 'error'
                            });
                        })
            }
        },
        addItem() {
            this.validated = false;
            this.validate()
            if(this.validated) {
                this.showeditmodal = false;
                const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }
                this.$toast.open({
                    message: "Processing : Adding a Quiz. Please Wait...",
                    type: 'info'
                })

                    axios.post(this.$apiURI + "/document/quiz/create", this.quiz, config)
                        .then((response) => {
                            this.loading = false;
                            if (response.data.error) {
                                this.$toast.open({
                                    message: "Error : " + response.data.message,
                                    type: 'error'
                                });

                            } else {
                                this.$toast.open({
                                    message: "A Quiz Created Successfully",
                                    type: 'success'
                                })
                                this.initData();

                            }

                        }).catch((error) => {
                            this.loading = false;
                            this.$toast.open({
                                message: "Error : " + error.response.data.message,
                                type: 'error'
                            });
                        })
            }
        },
        validate() {
            if (this.quiz.question == '') {
                this.$toast.open({
                        message: "Error : Please add a question",
                        type: 'error'
                    })
                this.validated = false;
                return;
            }

            if(this.modaltype == 'add') {
                if(this.quiz.mediaType == 'video') {
                    if(this.quiz.media == '') {
                        this.$toast.open({
                            message: "Error : Please add the vimeo video id",
                            type: 'error'
                        })
                        this.validated = false;
                        return;
                    }
                } else if (this.quiz.mediaType == 'image') {
                    if(this.$refs.media.files.length == 0) {
                        this.$toast.open({
                                message: "Error : Please add an image",
                                type: 'error'
                            })
                        this.validated = false;
                        return;
                    }
                }
            }


            if (this.quiz.correct == '') {
                this.$toast.open({
                        message: "Error : Please select a correct answer",
                        type: 'error'
                    })
                this.validated = false;
                return;
            }
            if (this.quiz.time == 0) {
                this.$toast.open({
                        message: "Error : Please add time of the quiz",
                        type: 'error'
                    })
                this.validated = false;
                return;
            }
            if (this.quiz.answerA == '') {
                this.$toast.open({
                        message: "Error : Please add a answer A",
                        type: 'error'
                    })
                this.validated = false;
                return;
            }
            if (this.quiz.answerB == '') {
                this.$toast.open({
                        message: "Error : Please add a answer B",
                        type: 'error'
                    })
                this.validated = false;
                return;
            }
            if (this.quiz.answerC == '') {
                this.$toast.open({
                        message: "Error : Please add a answer C",
                        type: 'error'
                    })
                this.validated = false;
                return;
            }
            if (this.quiz.answerD == '') {
                this.$toast.open({
                        message: "Error : Please add a answer D",
                        type: 'error'
                    })
                this.validated = false;
                return;
            }
            this.validated = true;
        }
    }
}
</script>
